import angular from 'angular'

/**
 * The first column within the sidebar, contains the first level nav items
 */
angular.module('vend.ui').directive('vdSidebarTabs', function () {
  return {
    link(scope, $element, attrs) {
      attrs.$addClass('vd-sidebar-tabs')
      attrs.$set('role', 'navigation')
    },
  }
})
